import { render, staticRenderFns } from "./TableTittle.vue?vue&type=template&id=352e5844&scoped=true&"
import script from "./TableTittle.vue?vue&type=script&lang=js&"
export * from "./TableTittle.vue?vue&type=script&lang=js&"
import style0 from "./TableTittle.vue?vue&type=style&index=0&id=352e5844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e5844",
  null
  
)

export default component.exports